type Props = {
  name: string;
  value: string;
};

export const PlatformInfoBlock = ({ name, value }: Props) => {
  return (
    <div className="p-2 rounded-lg border border-monochrome-100">
      <p className="typography-body-xs text-monochrome-600 whitespace-nowrap">
        {name}
      </p>
      <p className="typography-body-bold-sm">{value}</p>
    </div>
  );
};
